export const color_primary = "#54d4c6";
export const color_hover = "#249ca3";
export const color_dark = "#1f2427";
export const color_darker = "#000000";
export const color_light = "#F5F5F5";
export const color_error = "#d32f2f";